import { render, staticRenderFns } from "./app.vue?vue&type=template&id=0461d1e3"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"
import style0 from "./app.vue?vue&type=style&index=0&id=0461d1e3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Ad: require('/home/runner/work/pls-app/pls-app/components/ad.vue').default,BottomFooter: require('/home/runner/work/pls-app/pls-app/components/bottomFooter.vue').default})
